<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>多级别绑定等级</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">
          <Col span="6">
            <Form-item label="学生ID">
              <Input v-model="uid" placeholder="空则分页查全部"></Input>
            </Form-item>
          </Col>
          <Col span="8" style="padding-top: 4px;">
            <Button type="primary" :loading="tableLoading" icon="search" @click="search">查询</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <p style="margin: 8px 0 12px;">
      待分配 + 常规里 stars&gt;1 的学生。按学生分组。改课件 level 只改绑定，不重排已选课。
    </p>
    <table class="bind-level-table" border="1" cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th width="120">学生ID</th>
          <th width="180">姓名</th>
          <th>绑定老师时间</th>
          <th width="260">课件level</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="tableLoading">
          <td colspan="4" style="text-align:center;padding:16px;">加载中...</td>
        </tr>
        <tr v-else-if="!rows.length">
          <td colspan="4" style="text-align:center;padding:16px;">暂无数据</td>
        </tr>
        <tr v-for="(row, index) in rows" :key="row.rowKey || index">
          <td v-if="row.rowSpan" :rowspan="row.rowSpan">{{ row.uid }}</td>
          <td v-if="row.rowSpan" :rowspan="row.rowSpan">{{ row.nickname }}</td>
          <td>{{ row.tchTime }}</td>
          <td>
            <Select v-if="row.bindId" v-model="row.levelId" filterable transfer
                    @on-change="onLevelChange(row, $event)">
              <Option v-for="lv in levelOptions" :value="lv.id" :key="lv.id">{{ lv.title }}</Option>
            </Select>
            <span v-else>-</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="margin-top: 12px; text-align: right">
      <Page :total="totalCount" :current="pageIndex" :page-size="pageSize"
            show-total show-sizer @on-change="onPageChange" @on-page-size-change="onPageSizeChange"></Page>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      uid: '',
      tableLoading: false,
      saveLoading: false,
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      levelOptions: [],
      rows: []
    }
  },
  mounted () {
    this.loadLevels()
    this.loadList()
  },
  methods: {
    loadLevels () {
      let self = this
      self.$http.get('/bookMaterialLevel/listByCondition?status=1').then(function (res) {
        if (!res || res.status !== 'ok') {
          return
        }
        self.levelOptions = res.data || []
      })
    },
    search () {
      this.pageIndex = 1
      this.loadList()
    },
    onPageChange (page) {
      this.pageIndex = page
      this.loadList()
    },
    onPageSizeChange (size) {
      this.pageSize = size
      this.pageIndex = 1
      this.loadList()
    },
    loadList () {
      let self = this
      self.tableLoading = true
      let params = {
        pageIndex: self.pageIndex,
        pageSize: self.pageSize
      }
      if (self.uid && String(self.uid).trim() !== '') {
        params.uid = String(self.uid).trim()
      }
      self.$http.get('/user/lesson/listBindGroupLevel', {params: params}).then(function (res) {
        self.tableLoading = false
        if (!res || res.status !== 'ok') {
          return
        }
        let page = res.data || {}
        self.totalCount = page.totalCount || 0
        self.rows = self.flatten(page.data || [])
      }).catch(function () {
        self.tableLoading = false
      })
    },
    flatten (students) {
      let rows = []
      students.forEach(function (s) {
        let binds = (s.binds && s.binds.length) ? s.binds : [{}]
        binds.forEach(function (b, i) {
          rows.push({
            rowKey: s.uid + '-' + (b.bindId || 'empty') + '-' + i,
            uid: s.uid,
            nickname: s.nickname,
            bindId: b.bindId,
            tchTime: formatTchTime(b),
            levelId: b.levelId,
            savedLevelId: b.levelId,
            rowSpan: i === 0 ? binds.length : 0
          })
        })
      })
      return rows
    },
    onLevelChange (row, levelId) {
      let self = this
      if (!row.bindId || levelId == null || levelId === row.savedLevelId) {
        return
      }
      if (self.saveLoading) {
        row.levelId = row.savedLevelId
        return
      }
      self.saveLoading = true
      self.$http.post('/user/lesson/updateBindGroupLevel', {
        bindId: row.bindId,
        levelId: levelId
      }).then(function (res) {
        self.saveLoading = false
        if (!res || res.status !== 'ok') {
          row.levelId = row.savedLevelId
          return
        }
        row.savedLevelId = levelId
        self.$Message.success('已改绑定level')
      }).catch(function () {
        self.saveLoading = false
        row.levelId = row.savedLevelId
      })
    }
  }
}

function formatTchTime (b) {
  if (!b || !b.bindId) {
    return '无绑定'
  }
  let week = b.weekName || ''
  let time = b.startTimeStr || ''
  if (time && time.length >= 5) {
    time = time.substring(0, 5)
  }
  let tch = (b.tchId || '') + (b.tchName ? '-' + b.tchName : '')
  return [week, time, tch].filter(function (v) { return v }).join(' ')
}
</script>
<style scoped>
.bind-level-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}
.bind-level-table th,
.bind-level-table td {
  padding: 8px 10px;
  border: 1px solid #e9eaec;
  text-align: left;
  vertical-align: middle;
}
.bind-level-table th {
  background: #f8f8f9;
}
</style>



// WEBPACK FOOTER //
// BindGroupLevel.vue?83026c30